import { Box, Typography } from '@applift/factor'
import { useLoaderData } from '@tanstack/react-router'
import { ORGANIZATION_TYPE, useInitContext } from '@applift/platform'

import styles from './index.module.scss'
import { AuthLayout } from '../../components'

export const Invite = () => {
  const { landingPageImage, svgHostURL, organizationType, footerLinks } =
    useInitContext().initMeta

  const { reason } = useLoaderData({ from: '/invite' })

  const ihpImageURL = new URL('/assets/dist/misc/office-people.svg', svgHostURL)
    .href
  const nonIhpImageURL = new URL(
    '/assets/dist/brand/onboarding1Asset2.svg',
    svgHostURL
  ).href

  const bannerImageFallbackUrl =
    organizationType === ORGANIZATION_TYPE.SUPER ? ihpImageURL : nonIhpImageURL

  const bannerImageURL = landingPageImage || bannerImageFallbackUrl

  return (
    <AuthLayout bannerImage={bannerImageURL} footerLinks={footerLinks}>
      <Box className={styles.formContainer}>
        <Typography
          component="h1"
          variant="h4"
          weight="demi"
          lineHeight="multi-line"
        >
          {reason === 'INVITE_EXPIRED'
            ? 'Invitation Expired'
            : 'Invitation Invalid'}
        </Typography>
        <Typography
          component="p"
          variant="bodyMedium"
          sx={{ mb: 4, textColor: 'danger-400' }}
        >
          {reason === 'INVITE_EXPIRED'
            ? 'Uh Oh! Invitation link is expired'
            : 'The Invitation Link is invalid'}
        </Typography>
        {reason === 'INVITE_EXPIRED' ? (
          <Typography component="p" variant="bodyMedium">
            But don't worry, happens to the best of us.
          </Typography>
        ) : null}
      </Box>
    </AuthLayout>
  )
}
